import { useState } from 'react';
import { Btn } from '../../components/ui/Btn.jsx';
import { Inp } from '../../components/ui/Inputs.jsx';
import { CouleurMessage } from '../../components/CouleurMessage.jsx';
import { styleDuMessage } from '../../lib/styles-messages';
import { tr } from '../../lib/i18n';
import { C } from '../../theme/palette';

/**
 * « ✎ Modifier les messages » d'une facture payée.
 *
 * <p>Payée, la facture ne se modifie plus : ses montants sont comptés. Ses deux
 * messages, eux, se complètent encore — « un acompte a été versé le… » en haut
 * ou en bas, un mot au client — sans toucher aux montants. Le lien du client
 * montre aussitôt la nouvelle version.
 *
 * @param {object} props propriétés
 * @param {object} props.facture facture payée affichée
 * @param {(messages: {intro: string, piedMessage: string, stylesMessages: string}) => void} props.onEnregistre
 *   reçoit les deux messages à garder, avec leur couleur
 * @returns {import('react').ReactElement} le bouton, ou les deux cases
 */
export function MessagesFacture({ facture, onEnregistre }) {
  const [ouvert, setOuvert] = useState(false);
  const [intro, setIntro] = useState('');
  const [pied, setPied] = useState('');
  const [styles, setStyles] = useState('');
  if (!ouvert) {
    return (
      <Btn
        label={tr('✎ Modifier les messages')}
        color={C.navy}
        full
        onClick={() => {
          setIntro(facture.intro || '');
          setPied(facture.piedMessage || '');
          setStyles(facture.stylesMessages || '');
          setOuvert(true);
        }}
      />
    );
  }
  return (
    <div
      style={{
        border: '1px solid ' + C.border,
        borderRadius: 11,
        padding: 12,
        background: C.white,
      }}
    >
      <div style={{ fontSize: 10.5, color: C.muted, lineHeight: 1.5, marginBottom: 8 }}>
        {tr('Facture payée : les montants ne changent plus, les messages oui.')}
      </div>
      <Inp
        label={tr("Message au client (s'affiche en haut de la facture)")}
        rows={2}
        value={intro}
        onChange={(e) => setIntro(e.target.value)}
        styleTexte={styleDuMessage(styles, 'haut')}
        outil={<CouleurMessage styles={styles} quel="haut" onChange={setStyles} />}
      />
      <Inp
        label={tr('Message en bas du document (sous vos coordonnées)')}
        rows={3}
        value={pied}
        onChange={(e) => setPied(e.target.value)}
        styleTexte={styleDuMessage(styles, 'bas')}
        outil={<CouleurMessage styles={styles} quel="bas" onChange={setStyles} />}
      />
      <div style={{ display: 'flex', gap: 8 }}>
        <Btn
          label={tr('✓ Enregistrer les messages')}
          color={C.green}
          full
          onClick={() => {
            onEnregistre({ intro: intro.trim(), piedMessage: pied.trim(), stylesMessages: styles });
            setOuvert(false);
          }}
        />
        <Btn label={tr('Annuler')} ghost onClick={() => setOuvert(false)} />
      </div>
    </div>
  );
}
